import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private user: any;

  constructor(
    private router: Router,
    private api: ApiService,
    private http: HttpClient
  ) { }

  getUser() {
    const userString = sessionStorage.getItem('user');
    return this.user ? this.user : userString ? JSON.parse(userString) : null;
  }


  get userObj(): any {
    const userString = sessionStorage.getItem('user');
    this.user = userString ? JSON.parse(userString) : null;
    return this.user;
  }


  setUser(data: any) {
    this.user = data;
    sessionStorage.setItem('user', JSON.stringify(this.user));
  }

  getToken(): string | null {
    const user = this.getUser();
    return user?.token || null;
  }

  refreshToken() {
    return this.http.post(environment.serverUrl + '/users/auth/refresh-token', {}, {
      withCredentials: true
    });
  }

  updateToken(token: string, data?: any) {
    if (this.user) {
      this.user.token = token;
      if (data) Object.assign(this.user, data);
      sessionStorage.setItem('user', JSON.stringify(this.user));
    }
  }

  logout() {
    const vm = this;
    
    this.api.postData('/users/auth/logout', {}).subscribe({
      next: () => {
        vm.clearSessionAndNavigate();
      },
      error: () => {
        vm.clearSessionAndNavigate();
      }
    });
  }

  private clearSessionAndNavigate() {
    sessionStorage.removeItem('user');
    this.router.navigate(['/']);
  }
}
